'use client';
import React from 'react';
import { sectionHeadingTag } from '@/components/dynamic-zone/section-heading-level';
import { components } from '@/types/strapi';
import { BlogCardVertical } from '../blog/blog-card';

export const RelatedArticles = ({
	heading,
	articles,
	locale,
	isFirst = false,
}: {
	heading: string;
	articles: components['schemas']['Article'][];
	locale: string;
	isFirst?: boolean;
}) => {
	const SectionHeading = sectionHeadingTag(isFirst);
	return (
		<div className="mt-12 pb-20">
			<SectionHeading className="mb-10 text-2xl font-bold text-neutral-200">
				{heading}
			</SectionHeading>
			<div className="grid grid-cols-1 gap-10 md:grid-cols-3">
				{articles.map(article => (
					<BlogCardVertical
						key={article.title}
						article={article}
						locale={locale}
					/>
				))}
			</div>
		</div>
	);
};
